import React, { useCallback, useEffect } from "react";
import { TextInput, createStyles } from "@mantine/core";
import { IconSearch } from "@tabler/icons-react";
import { debounce } from "../../utils"; // Assuming debounce function is in utils
import useDebounce from "../../utils/useDebounce";

const useStyles = createStyles((theme) => ({
  row: {
    display: "flex",
    width: "100%",
    borderRadius: "10px",
    border: "1px solid var(--app-border)",
    background: "var(--app-surface)",
    height: "48px",
    alignItems: "center",
    overflow: "hidden",
  },

  searchbox: {
    width: "100%",
    "& input": {
      height: "48px",
      fontSize: "13px",
      fontWeight: 400,
      color: "var(--app-text)",
      fontFamily: "Inter",
      background: "transparent",
      paddingLeft: "44px",
      "&::placeholder": {
        color: "var(--app-text-muted)",
        fontWeight: 400,
      },
    },
    "& .mantine-Input-icon": {
      left: "14px",
      width: "18px",
      color: "var(--app-text-muted)",
    },
  },
}));

function BillingSearchAll({
  placeholder,
  onChange,
  value,
  setValue,
  ...props
}) {
  const { classes } = useStyles();


  // const debouncedSearch = useCallback(
  //   debounce((value) => {
  //     onChange(value); 
  //   }, 2000),
  //   [onChange] 
  // );


  const debouncedSearch = useDebounce(value, 2000); 
  
  useEffect(() => {
    if (debouncedSearch) {
      onChange(value); 
    } else {
      onChange(value); 
    }
  }, [debouncedSearch]);

  // const useDebounce = (value, delay = 300) => {
  //   const [debouncedValue, setDebouncedValue] = useState(value);
  
  //   useEffect(() => {
  //     const handler = setTimeout(() => {
  //       setDebouncedValue(value);
  //     }, delay);
  
  //     return () => {
  //       clearTimeout(handler); // Cleanup timeout on every new keystroke
  //     };
  //   }, [value, delay]);
  
  //   return debouncedValue;
  // };

  const handleChange = (value) => {
    setValue(value);
  };

  return (
    <div>
      <div className={classes.row}>
        <TextInput
          style={{
            color: "var(--app-text-muted)",
            fontFamily: "Inter",
            fontSize: "14px",
            fontWeight: "500",
          }}
          {...props}
          // rightSection={<IconSearch size={25} />}
          icon={<IconSearch size={16} />}
          // rightSectionWidth={30}
          className={classes.searchbox}
          placeholder={placeholder}
          value={value}
          variant="unstyled"
          onChange={(e) => handleChange(e.target.value)}
        />
      </div>
    </div>
  );
}

export default BillingSearchAll;
